import React from 'react';
import { StyledMlpTittleWrapper, StyledSalesEventLogoWrapper } from './styled';
import {
  Breakpoints,
  CustomImage,
  TextAppearance,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';
import { AppConstants } from '../../../utils/app-constants';
import { OfferTag } from '../../../components/icons/OfferTag';

interface SalesEventMlpLogoProps {
  sales_event_logo_url_light?: string;
  title: string;
}

const SalesEventMlpLogo: React.FC<SalesEventMlpLogoProps> = ({
  sales_event_logo_url_light,
  title,
}) => {
  return sales_event_logo_url_light ? (
    <StyledSalesEventLogoWrapper>
      <CustomImage
        src={sales_event_logo_url_light}
        alt="Sales_Event_Logo"
        srcPlaceholder={AppConstants.PlaceHolder480x216 as string}
      />
    </StyledSalesEventLogoWrapper>
  ) : (
    <StyledMlpTittleWrapper>
      <OfferTag />
      <TextCustom
        appearance={TextAppearance.headline300}
        tag={TextTag.p}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize20,
            fontWeight: TextWeight.bold,
            lineHeight: TextLineHeight.TextLineHeight24,
          },
          [Breakpoints.b960]: {
            fontSize: TextSize.TextSize32,
            fontWeight: TextWeight.bold,
            lineHeight: TextLineHeight.TextLineHeight36,
          },
          [Breakpoints.b1600]: {
            fontSize: TextSize.TextSize48,
            fontWeight: TextWeight.bold,
            lineHeight: TextLineHeight.TextLineHeight56,
          },
        }}
      >
        {title}
      </TextCustom>
    </StyledMlpTittleWrapper>
  );
};

export default SalesEventMlpLogo;
